import FetchAiCostLimitUsers from '@Application/AiCostLimits/Users/Queries/FetchAiCostLimitUsers';
import fetchAiCostLimitUsers from '@Application/AiCostLimits/Users/fetchAiCostLimitUsers';
import ErrorState from '@Guidelines/Component/ErrorState';
import { theme } from '@Guidelines/Theme/theme';
import type AiCostLimitUsersListView from '@UI/Store/AiCostLimits/Views/AiCostLimitUsersListView';
import * as React from 'react';
import { useDispatch, useStoreQuery } from '@verclam/synapse';
import { Skeleton } from '@verclam/ui-kit';

type Props = {
	readonly accountId: number;
	readonly children: (users: AiCostLimitUsersListView) => React.ReactNode;
};

/** Loads the account's users, since their names are not in the limits, then renders `children` with them. */
const AiCostLimitUsersLoader: React.FC<Props> = ({ accountId, children }) => {
	const dispatch = useDispatch();

	const {
		data: users,
		error,
		refetch,
	} = useStoreQuery({
		selector: (state) => state.aiCostLimitsStore.users,
		stopOn: (value) => value !== null && value.accountId === accountId,
		query: () => dispatch(fetchAiCostLimitUsers(new FetchAiCostLimitUsers(accountId))),
		deps: [accountId],
	});

	if (error !== null) {
		return <ErrorState title="Impossible de charger les utilisateurs du compte." onRetry={refetch} />;
	}

	if (users === null || users.accountId !== accountId) {
		return (
			<Skeleton height="5rem" borderRadius={theme.radii.xlarge} animation="wave" shape="rectangle" />
		);
	}

	return <React.Fragment>{children(users)}</React.Fragment>;
};

export default AiCostLimitUsersLoader;
